<script setup lang="ts">
import { onMounted, ref } from 'vue'

const showContent = ref(false)

onMounted(() => {
  // Small delay for smooth animation
  setTimeout(() => {
    showContent.value = true
  }, 100)
})
</script>

<template>
  <div class="min-h-screen bg-white flex items-center justify-center p-4">
    <div class="max-w-2xl w-full text-center">
      <!-- Title -->
      <h1 class="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
        {{ $t('maintenance.title', 'We\'re taking time out for maintenance') }}
      </h1>
      
      <!-- Subtitle -->
      <p class="text-xl text-gray-600 mb-12">
        {{ $t('maintenance.message', 'We hope to be back soon with more features.') }}
      </p>

      <!-- Maintenance Illustration -->
      <div class="w-3/4 max-w-lg mx-auto">
        <img 
          src="/images/maintenance.jpg" 
          alt="Maintenance illustration" 
          class="w-full h-auto"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Ensure full height and prevent scrolling */
html, body {
  height: 100%;
  overflow: hidden;
}
</style>